import { DraggableNode } from "./draggableNode";
import { useTheme } from "./themeContext";
import { useStore } from "./store";
import { Sun, Moon, Trash2 } from "lucide-react";

export const PipelineToolbar = () => {
  const { isDark, toggleTheme } = useTheme();
  const { nodes, clearGraph } = useStore();

  return (
    <div className="p-5 mt-5">
      <div className="absolute top-20 left-4 right-4 md:top-4 md:right-auto z-10 glass-panel p-4 rounded-xl w-auto md:w-[300px] transition-all duration-300">
        <div className="mb-2 pb-2 border-b border-light-border dark:border-white/10 flex justify-between items-center gap-4">
          <h2 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider flex-1">Components</h2>

          <button
            onClick={clearGraph}
            disabled={nodes.length === 0}
            className={`
              p-1.5 rounded-lg transition-colors
              ${nodes.length === 0
                ? "text-gray-300 dark:text-gray-600 cursor-not-allowed bg-transparent"
                : "text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20"
              }
            `}
            title="Clear Pipeline"
          >
            <Trash2 size={16} />
          </button>

          <button
            onClick={toggleTheme}
            className="p-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-white/5 dark:hover:bg-white/10 transition-colors text-gray-600 dark:text-gray-300"
          >
            {isDark ? <Sun size={16} /> : <Moon size={16} />}
          </button>
        </div>
        <div className="flex flex-wrap gap-3">
          <DraggableNode type="customInput" label="Input" />
          <DraggableNode type="llm" label="LLM" />
          <DraggableNode type="customOutput" label="Output" />
          <DraggableNode type="text" label="Text" />
          <DraggableNode type="math" label="Math" />
          <DraggableNode type="delay" label="Delay" />
          <DraggableNode type="condition" label="Condition" />
          <DraggableNode type="api" label="API Call" />
          <DraggableNode type="image" label="Image" />
        </div>
      </div>
    </div>
  );
};
